<template>
  <div class="pagination_wrap">
    <div class="pagination" v-if="paginationData.total > 0">
<!--      <el-button class="pagination_button_go_first" icon="el-icon-d-arrow-left" :disabled="paginationData.page===1"-->
<!--                 :class="[paginationData.page ===1 ? 'normal' : 'active']"-->
<!--                 @click="changePage('page',paginationData.page=1)"-->
<!--      ></el-button>-->
      <el-button class="pagination_button_go_prev" icon="el-icon-arrow-left" :disabled="paginationData.page === 1"
                 :class="[paginationData.page === 1 ? 'normal' : 'active']"
                 @click="changePage('page',paginationData.page-1)"></el-button>
      <el-pagination
          :page-size="paginationData.size"
          :current-page.sync="paginationData.page"
          :pager-count="5"
          layout="pager"
          :total="paginationData.total"
          @current-change="changePage('page', paginationData.page)"
          class="pagination_page_number"
      ></el-pagination>
      <el-button class="pagination_button_go_next" icon="el-icon-arrow-right"
                 :class="[paginationData.page === returnLastPage() ? 'normal' : 'active']"
                 :disabled="paginationData.page === returnLastPage()"
                 @click="changePage('page',paginationData.page+1)"></el-button>
<!--      <el-button class="pagination_button_go_last" icon="el-icon-d-arrow-right"-->
<!--                 :class="[paginationData.page === returnLastPage() ? 'normal' : 'active']"-->
<!--                 :disabled="paginationData.page === returnLastPage()"-->
<!--                 @click="changePage('page',paginationData.page=returnLastPage())"-->
<!--      ></el-button>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "PaginationDefaultLayout",
  mixins: [],
  components: {},
  inject: ['setPage'],
  provide() {
    return {}
  },
  props: {
    paginationData: {
      type: Object,
      default: {
        total: 0,
        page: 0,
        size: 0,
      }
    },
    listLength: {
      default: 0
    }
  },
  data() {
    return {
      page: 1,
      size: 5,
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    changePage(key, value) {
      this.setPage(key, value)
      window.scrollTo(0, 0)
    },
    returnLastPage() {
      return Math.ceil(this.paginationData.total / this.paginationData.size);
    },
    totalSize(value) {
      let total = 5 * this.paginationData.size;
      let page = value + total;

    }
  },
  watch: {},
}
</script>

<style scoped>

</style>